import styled from "@emotion/styled";

export interface ProfileIconImageProps {
  borderRadius: number | string;
  size: number;
}

export const ProfileIconImage = styled.img<ProfileIconImageProps>`
  border-radius: ${props =>
    typeof props.borderRadius === "string" ? props.borderRadius : `${props.borderRadius}px`};
  width: ${props => props.size}px;
  height: ${props => props.size}px;
`;
